import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import Quoteth from 'Quoteth';

ReactDOM.render(<Quoteth />, document.getElementById('root'));
